import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {TaskService} from '../../../../services/task.service';

@Component({
  selector: 'app-common-timer-notification',
  templateUrl: './common-timer-notification.component.html',
  styleUrls: ['../parts.css']
})
export class CommonTimerNotificationComponent implements OnInit {

  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据

  recipeId = '';

  // 定时
  schedulerConditionDisplayText = '定时'; // 定时默认文字
  schedulerConditionData: any; // 存放定时数据
  schedulerConditionVisible: boolean; // 定时pop是否关闭

  mailPopVisible = false;
  receiverPopVisible = false;
  instanceData: any = {}; // 存放实例返填数据

  smsPattern = 'custom';
  smsTemplateList;
  notificationData: any; // 存放通知组件数据

  automation = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    email: null,
    siteMessage: null,
    sms: null,
    receiver: {
    },
    schedulerConfig: {},
    schedulerDescription: '',
    instanceDescription: ''
  }; // 存放入参数据
  constructor(
    private taskService: TaskService
  ) { }

  ngOnInit() {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    // 初始化自动化数据
    if (this.instanceData && this.instanceData.config) {
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.schedulerConditionData = this.instanceData.config.schedulerConfig;
      this.schedulerConditionDisplayText = this.instanceData.config.schedulerDescription;
      this.notificationData = this.instanceData.config.email || this.instanceData.config.siteMessage || this.instanceData.config.sms;
    }
    if (this.smsPattern === 'template') {
      this.taskService.querySmsTemplateList().subscribe(res => {
        this.smsTemplateList = res;
        if (this.smsTemplateList && this.smsTemplateList.length > 0) {
          for (const template of this.smsTemplateList) {
            template['content'] = JSON.parse(template['content']);
          }
        }
      });
    }
    this.packageData();
  }

  // 获取定时数据
  getSchedulerData(event) {
    this.schedulerConditionVisible = false;
    this.schedulerConditionDisplayText = event.text;
    this.schedulerConditionData = event.config;
    this.automation.schedulerDescription = this.schedulerConditionDisplayText;
    this.automation.schedulerConfig = this.schedulerConditionData;
    this.packageData();
  }

  getNotificationData(data) {
    this.notificationData = data.content;
    if (data.type === 'email') {
      this.automation.email = data.content;
      this.automation.siteMessage = null;
      this.automation.sms = null;
    } else if (data.type === 'siteMessage') {
      this.automation.siteMessage = data.content;
      this.automation.email = null;
      this.automation.sms = null;
    } else {
      this.automation.sms = data.content;
      this.automation.email = null;
      this.automation.siteMessage = null;
    }
    this.mailPopVisible = false;
    this.packageData();
  }

  getUserData(data) {
    this.automation.receiver = data;
    this.packageData();
  }

  packageData() {
    const text = this.schedulerConditionDisplayText ?
      `${this.schedulerConditionDisplayText.slice(0, 24)}...` : this.schedulerConditionDisplayText;
    this.automation.instanceDescription = text + ' ， 发 通知 给 客户';
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return this.schedulerConditionData && (this.automation.email || this.automation.siteMessage || this.automation.sms) &&
      (this.automation.receiver && this.automation.receiver['value'] && this.automation.receiver['value'].length > 0);
  }
}
